import { useEffect, useState } from "react";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { SpotsMeter } from "@/components/site/SpotsMeter";

export default function Login() {
  const [params] = useSearchParams();
  const [mode, setMode] = useState(params.get("mode") === "register" ? "register" : "login");
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const { user, signedIn } = useAuth();
  const location = useLocation();

  useEffect(() => { setErr(""); }, [mode]);

  if (user) return <Navigate to={location.state?.from || (params.get("type") === "partner" ? "/partner-intake" : user.role === "admin" ? "/admin" : "/dashboard")} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const body = mode === "register" ? f : { email: f.email, password: f.password };
      const { data } = await api.post(`/auth/${mode}`, body);
      signedIn(data);
    } catch (ex) {
      setErr(errMsg(ex));
    } finally {
      setBusy(false);
    }
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid lg:grid-cols-2 gap-14 items-center" data-testid="login-page">
      <div className="hidden lg:block">
        {params.get("type") === "partner" ? (
          <>
            <span className="eyebrow">For referral partners</span>
            <h1 className="font-display text-5xl font-black tracking-tight mt-4 leading-[1.05]">Join the 1031 Club. <span className="text-qi-pink">Free.</span></h1>
            <p className="text-white/55 mt-5 max-w-md leading-relaxed">CPAs, attorneys, brokers and advisors: create your account, tell us about your practice, and once approved you can chat with QIs and send them client referrals.</p>
          </>
        ) : (
          <>
        <span className="eyebrow">For qualified intermediaries</span>
        <h1 className="font-display text-5xl font-black tracking-tight mt-4 leading-[1.05]">Get listed. Get leads. <span className="text-qi-pink">Get connected.</span></h1>
        <p className="text-white/55 mt-5 max-w-md leading-relaxed">Create your account, complete a short intake, and once approved your firm appears in the directory with a direct investor contact line.</p>
        <div className="mt-8"><SpotsMeter /></div>
          </>
        )}
      </div>
      <div className="glass-card p-8 md:p-10 max-w-md w-full mx-auto">
        <div className="flex bg-white/5 rounded-full p-1 mb-8">
          {["login", "register"].map((m) => (
            <button key={m} onClick={() => setMode(m)} data-testid={`login-tab-${m}`}
              className={`flex-1 py-2.5 rounded-full text-sm font-bold transition-colors ${mode === m ? "bg-qi-pink text-white" : "text-white/60 hover:text-white"}`}>
              {m === "login" ? "Sign in" : "Create account"}
            </button>
          ))}
        </div>
        <form onSubmit={submit} className="space-y-3">
          {mode === "register" && <input required placeholder="Full name" className="field" value={f.name} onChange={set("name")} data-testid="register-name-input" />}
          <input required type="email" placeholder="Email" className="field" value={f.email} onChange={set("email")} data-testid="login-email-input" />
          <input required type="password" minLength={mode === "register" ? 8 : 1} placeholder={mode === "register" ? "Password (8+ characters)" : "Password"} className="field" value={f.password} onChange={set("password")} data-testid="login-password-input" />
          {err && <p className="text-sm text-red-400" data-testid="login-error">{err}</p>}
          <button disabled={busy} className="btn-pink w-full" data-testid="login-submit-button">{busy ? "Please wait..." : mode === "login" ? "Sign in" : "Create account"}</button>
        </form>
      </div>
    </div>
  );
}
